import { Temporal } from 'temporal-polyfill';
import type { ClockType } from '@/models/common/clock.ts';

const initialClockObject = {
  getTimeZone: () => Intl.DateTimeFormat().resolvedOptions().timeZone,
  getInstant: () => Temporal.Now.instant(),
  getPlainDateISO: () => Temporal.Now.plainDateISO(),
  getZonedDateTimeISO: () =>
    Temporal.Now.zonedDateTimeISO(
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    ),
};

export const realClock: ClockType = initialClockObject;
